module.exports = __webpack_public_path__ + "ce4a07ddd7abc21771f310ce24a8108c.woff";